<template>
  <div class="VidComponent">
    <div  class="videoContainer">
      <video v-on:mouseenter="fadePlay(1)" v-on:mouseleave="fadePlay(2)" height="100%" width="100%"  v-if="option == 1" id='video' playsinline ref='why_video'
             v-on:click='updateVideo'  :poster='videoProp.poster'>
        <source :src='videoProp.url' type='video/mp4'>
      </video>
      <div v-on:click="playPause()" v-on:mouseleave="fadePlay(2)" v-on:mouseenter="fadePlay(3)" v-if="!vidPlay" class="playbtn" >
        <div class="playIco" v-html="playIcon"> </div>
      </div>
      <div v-on:click="playPause()" v-on:mouseleave="fadePlay(2)" v-on:mouseenter="fadePlay(3)" v-if="vidPlay"  class="playbtn" >
        <div  class="playIco" v-html="pauseIcon"> </div>
      </div>
      <div class="video-progress">
        <!--              <div id="progress-bar-fill" class="progress-bar-fill">-->
        <!--              </div>-->
        <input style="width:100%" type="range" id="seek-bar"  value="0">

      </div>
      <button id="fs"  v-on:click="fullscreen()"><span v-html="fsIcon"></span></button>

    </div>

    <div :class="videoProp.classes" class="buttons-container">
      <button v-for="item in videoProp.buttons" class="btn-outline-primary" v-on:click="setTime(item.time)">{{item.name}}</button>
    </div>
<!--    <div class="buttons-container">-->
<!--      <button :class="btnClass(1)" v-on:click="setTime(0)">Zero Defects</button>-->
<!--      <button :class="btnClass(2)" v-on:click="setTime(2)">Introduction to Process Standardisation</button>-->
<!--      <span style="flex:auto"></span>-->
<!--      <button id="fs" class="btn-outline-primary" v-on:click="fullscreen()">Play Fullscreen</button>-->
<!--    </div>-->
  </div>
</template>

<script>

import iconService from "@/services/iconService";

export default {
  name: "VidComponent",
  data () {
    return {
        vidPlay: false,
        acronymsState: false,
        homeState: false,
        option: 1,
        playIcon: iconService.icons.Play,
        pauseIcon: iconService.icons.Pause,
        fsIcon: iconService.icons.Fullscreen,

      player: null,
        videoContainer: document.getElementById('videoContainer')
    }
  },
  props:{
    //vid object for file and skip points
    videoProp: {}
  },
  mounted() {
    this.video = document.getElementById('video');
    this.player = document.getElementById('video-element');
    this.progressBar = document.getElementById('progress-bar');
    this.seek = document.getElementById('seek');
    this.seekBar = document.getElementById("seek-bar");
    //add self for scoping in event listener
    let self = this;
    this.seekBar.addEventListener("change", function() {
      // Calculate the new time
      let time = self.video.duration * (self.seekBar.value / 100);

      // Update the video time
      self.video.currentTime = time;
    });
    this.seekBar.addEventListener("mousedown", function() {
      self.video.pause();
    });
    // Play the video when the slider handle is dropped
    this.seekBar.addEventListener("mouseup", function() {
      self.video.play();
    });
    this.video.addEventListener("playing", function(){

      self.vidPlay = true;
    });
    this.video.addEventListener("pause", function(){

      self.vidPlay = false;
    })
    this.video.addEventListener("timeupdate", function() {
      // Calculate the slider value
      let value = (100 / self.video.duration) * self.video.currentTime;

      // Update the slider value
      self.seekBar.value = value;
    });
    // var video = document.getElementById('video');
    // var videoControls = document.getElementById('video-controls');
  },
  methods: {
    playPause() {
      let video = document.getElementById("video");

      if (video.paused){
        video.play();
        //   this.vidPlay = true;
      }
      else{
        video.pause();
        //   this.vidPlay = false;
      }

    },

    fadePlay(state){
      let playbtn = document.getElementsByClassName('playbtn');
      if(state == 1){
        playbtn[0].style.opacity = 0.5;

      }
      else if(state == 2){
        playbtn[0].style.opacity = 0;
      }
      else if(state == 3){
        playbtn[0].style.opacity = 1;
      }

    },
    // Update progress bar as the video plays
    // updateProgress(){
    //   // let video= document.getElementById('video');
    //   // Calculate current progress
    //   let value = (100 / this.video.duration) * this.video.currentTime;
    //   console.log("currentTime", value);
    //   // Update the slider value
    //   this.progressBarFill.style.width = value + '%';
    // },

    initializeVideo() {
      let video= document.getElementById('video');
      const videoDuration = Math.round(video.duration);
      this.seek.setAttribute('max', videoDuration);
      this.progressBar.setAttribute('max', videoDuration);

    },
    fullscreen(){
      let videoContainer= document.getElementById('videoContainer');
      let video= document.getElementById('video');
      //check if fullscreen is supported
      if (this.isFullScreen()) {
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
        else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
        else if (document.msExitFullscreen) document.msExitFullscreen();
        this.setFullscreenData(false);
      }
      else {
        if (video.requestFullscreen) video.requestFullscreen();
        else if (video.mozRequestFullScreen) video.mozRequestFullScreen();
        else if (video.webkitRequestFullScreen) video.webkitRequestFullScreen();
        else if (video.msRequestFullscreen) video.msRequestFullscreen();

        this.setFullscreenData(true);
      }

    },
    setFullscreenData(state) {
      let video= document.getElementById('video');
      if (state == true){
        video.setAttribute('style', 'width:100%; margin:0');
      } else {
        video.setAttribute('style', 'width:75%');
      }

      this.videoContainer.setAttribute('data-fullscreen', !!state);
    },
    isFullScreen() {
      return !!(document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
    },
    setTime(time){
      //this.option = option;
      this.video.currentTime = time;
    },
    btnClass(btn){
      if(this.option == btn){
        return 'btn-outline-primary btn-active';
      }
      else {
        return 'btn-outline-primary';
      }
    },
    updateVideo () {
      let video = this.$refs['why_video'];
      video.paused ? video.play() : video.pause();
    },
  },
}
</script>
<style scoped>
.btn-active{
  color: white;
  background: #007bff;
  display: flex;
  margin-right: 15px;
  font-size: 25px;
  padding: 10px;
  border: 1px solid #007bff;
  border-radius: 5px;
}
.videoContainer{
  position: relative;
}
.content{
  width: 100%;
}
.buttons-container{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  max-width: 1280px;
  margin-top: 50px;
}

.container-override { margin-top: 25px}


#fs{
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  opacity: 0.5;
}
#fs:hover{
  opacity: 1;
}
#controls {
  border: 1px solid darkgreen;
  width: 420px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-top: 5px;
  padding-bottom: 3px;
  border-radius: 7px;
}
.playbtn{
  cursor: pointer;
  opacity:0.5;
  top:45%;
  left: 45%;
  position: absolute;
  border: 4px solid white;
  min-height: 128px;
  min-width: 128px;
  border-radius: 68px;
  background: #006DFF;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  transition-property: opacity;
  transition-duration: 0.5s;
  transition-timing-function: linear;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .playIco{
    margin-top:25px;
  }
}


.playbtn:hover{
  opacity: 1;
}

.video-progress{
  width: 100%;
  position: absolute;
  bottom: 0;
  cursor: pointer;
}
.progress-bar-fill {
  width: 0;
  height: 4px;
  background-color: #E21D60;
  transition: width .35s linear;

}
input[type=range]:focus {
  outline: none;
}
input[type=range]{
  width: 100%;
  -webkit-appearance: none;
  background: transparent;
  border-radius: 0;
}
input[type=range]::-webkit-slider-runnable-track {
  cursor: pointer;
  width: 100%;
  height: 15px;
  animate: 0.2s;
  background: transparent;
}
input[type='range']::-webkit-slider-thumb {
  width: 10px;
  -webkit-appearance: none;
  height: 15px;
  cursor: ew-resize;

}
input[type=range]::-ms-fill-lower {
  background: #E21D60;
}
/* IE*/
input[type=range]:focus::-ms-fill-lower {
  background: #E21D60;
}
/* FF */
input[type="range"]::-moz-range-track {
  height: 15px;
}
input[type="range"]::-moz-range-progress {
  background-color: #E21D60;
  height: 15px;
}
input[type="range"]::-moz-range-thumb {
  width: 10px;
  -webkit-appearance: none;
  height: 15px;
  cursor: ew-resize;
  background: #E21D60;
  border-radius: 0;
  border: none;
}
/*Chrome*/
@media screen and (-webkit-min-device-pixel-ratio:0) {
  input[type='range'] {
    overflow: hidden;
    width: 80px;
    -webkit-appearance: none;
  }

  input[type='range']::-webkit-slider-runnable-track {
    height: 15px;
    -webkit-appearance: none;
    margin-top: -1px;
  }

  input[type='range']::-webkit-slider-thumb {
    width: 10px;
    -webkit-appearance: none;
    height: 15px;
    cursor: ew-resize;
    box-shadow: -100vw 0 0 100vw #E21D60;
    background: #E21D60;
  }
}
</style>